// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3FIj5","left":"styles_left__3gm8V","desktopActions":"styles_desktopActions__1_ouR","title":"styles_title__XeqfP"};